import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentPromptCardClickedId } from './useTrackAgentPromptCardClicked.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export {
  WORKSPACE_AGENT_PROMPT_CARD_CLICKED_IDS,
  type WorkspaceAgentPromptCardClickedId,
} from './useTrackAgentPromptCardClicked.meta';

export type UseTrackAgentPromptCardClickedParams = {
  card_id: WorkspaceAgentPromptCardClickedId;
};

export const useTrackAgentPromptCardClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentPromptCardClicked = useCallback(
    (params: UseTrackAgentPromptCardClickedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentPromptCardClicked };
};
